export enum TemplateSelectorViewTypes {
  Grid = 'grid',
  Register = 'register',
}
